import { ReactElement, useContext } from "react";
import classNames from "classnames";
import { setTrackingId } from "client/Misc/utils";
import { ControlAttachmentContext, ControlAttachmentOptions, getAttachmentClassNames } from "../ControlAttachment";
import inputStyles from "../TextInput/TextInput.module.less";
import styles from "./InputLike.module.less";

export type InputLikeProps = {
	value: string | ReactElement | null;
	isInvalid?: boolean;
	isDisabled?: boolean;
	isBorderless?: boolean;
	hasNoPadding?: boolean;
	height?: "auto" | "fill";
	attachedOn?: ControlAttachmentOptions;
	trackingId?: string;
};

export const InputLike = (props: InputLikeProps): ReactElement => {
	const {
		value,
		isInvalid = false,
		isDisabled = false,
		attachedOn = [],
		isBorderless = false,
		hasNoPadding = false,
		height = "auto",
		trackingId
	} = props;

	const {
		attachedOn: attachedOnFromContext
	} = useContext(ControlAttachmentContext);

	return (
		<span
			{...setTrackingId(trackingId)}
			className={classNames(
				styles.root,
				inputStyles.root,
				{
					[inputStyles.root_isInvalid]: isInvalid,
					[styles.root_isDisabled]: isDisabled,
					[inputStyles.root_borderless]: isBorderless,
					[inputStyles.root_noPadding]: hasNoPadding,
					[inputStyles.root_fillHeight]: height === "fill"
				},
				getAttachmentClassNames(attachedOn, attachedOnFromContext)
			)}
		>
			<span className={styles.content}>
				{value}
			</span>
		</span>
	);
};
InputLike.displayName="InputLike";